import { render, staticRenderFns } from "./complaint-dashboard.vue?vue&type=template&id=7432fb9f&scoped=true&"
import script from "./complaint-dashboard.vue?vue&type=script&lang=js&"
export * from "./complaint-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./complaint-dashboard.vue?vue&type=style&index=0&id=7432fb9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7432fb9f",
  null
  
)

export default component.exports